/**
 * Work arrangements (ADR 0046, 0051): work by the hour, one visit, some days a week or by the month, as fits the job.
 * The worker's card asks which they take and a rate for each; Find asks the household before the estimate.
 */
export const arrangement = {
    "question.arrangement": "How long is the work for?",
    "detail.arrangement": "how long",
    "arrangement.hourly": "by the hour",
    "arrangement.visit": "one visit",
    "arrangement.weekly": "some days a week",
    "arrangement.monthly": "by the month",
    "unit.hour": "an hour",
    "unit.visit": "a visit",
    "unit.week": "a week",
    "unit.month": "a month",
    "price.per": "{price} {unit}",
    "estimate.range_week": "{trade} in {city}{scope}: usually {low}–{high} a week.",
    "need.ask.arrangement": "How long do you need them for?",
    "need.arr.hourly": "A few hours",
    "need.arr.visit": "Just once",
    "need.arr.weekly": "Some days a week",
    "need.arr.monthly": "Every month",
    "need.arr.meal": "One meal or occasion",
    "need.field_arrangement": "How long",
    "need.summary_arrangement": "Work: {arrangement}.",
    "need.budget_per.hour": "That is the most for one hour.",
    "need.budget_per.visit": "That is the most for the one visit.",
    "need.budget_per.week": "That is the most for a week.",
    "need.budget_per.month": "That is the most for a month.",
    "iv.ask.arrangements": "Which kinds of work do you take? Tap each one, then Done.",
    "iv.done": "Done",
    "iv.err_arrangements": "Tap at least one kind of work.",
    "iv.picked": "You take work {list}.",
    "iv.ask.rate_hour": "How much do you take for an hour?",
    "iv.ask.rate_week": "How much do you take for a week?",
    "iv.summary_rate": "{arrangement}: {rate}.",
    "card.arrangements": "Work I take",
    "card.rate.hourly": "Rate for an hour, ₹",
    "card.rate.visit": "Rate for one visit, ₹",
    "card.rate.weekly": "Rate for a week, ₹",
    "card.rate.monthly": "Rate for a month, ₹",
    "card.err_arrangements": "Pick at least one kind of work, with a rate for each.",
    "card.radius": "How far I go",
    "card.km": "{km} km",
};
//# sourceMappingURL=arrangement.js.map